export function loading() {
    const loading = document.querySelector('.loading-fade');
    if (loading) {
        loading.classList.add('loading-fadeout');
        setInterval(() => {
                loading.style.display = "none";
        }, 500);
    }
}